export const IS_SERVER = typeof window === 'undefined';
export const IS_CLIENT = !IS_SERVER;
export const IS_WEBVIEW = !IS_SERVER && !!window?.ReactNativeWebView;
